

















































import Vue from 'vue';

export default Vue.extend({
	name: 'ReservationLocation',

	props: {
		featuredImage: Boolean,
		icons: Boolean,
		map: Boolean,
		quote: Object,
		res_quote: Boolean || false,
	},

	computed: {
		address(): string {
			if (this.res_quote) {
				return this.$store.getters['reservation/address'] || this.quote.location_information.address;
			}
			if (this.settings.display_all_quotes_from_locations === 1) {
				return this.$store.getters['reservation/quote'].location_information.address || this.$store.getters['reservation/address'];
			}
			return this.$store.getters['reservation/address'] || this.$store.getters['location/address'];
		},

		settings(): Locations.Settings {
			return this.$store.getters['location/settings'];
		},

		location(): Locations.Location {
			return this.$store.getters['location/location'];
		},

		details(): Locations.Details {
			if (this.res_quote) {
				return this.quote.location_information;
			} if (this.settings.display_all_quotes_from_locations === 1) {
				return this.$store.getters['reservation/quote'].location_information;
			}
			return this.$store.getters['reservation/zonePhone'] || this.$store.getters['location/details'];
		},

		check_classes(): string {
			if (this.res_quote) {
				return 'np-flex np-flex-wrap';
			}
			return 'np-reservation-location np-flex np-flex-wrap np--mx-4';
		},

		locationEmail(): string {
			if (this.res_quote) {
				return this.quote.location_information.email;
			}
			if (this.settings.display_all_quotes_from_locations === 1) {
				return this.$store.getters['reservation/quote'].location_information.email;
			}
			return this.$store.getters['reservation/zoneEmail'] || this.$store.getters['location/email'];
		},

		locationName(): string {
			if (this.res_quote) {
				return this.quote.location_information.name;
			}
			if (this.settings.display_all_quotes_from_locations === 1) {
				return this.$store.getters['reservation/quote'].location_information.name;
			}
			return this.$store.getters['location/locationName'] || this.$store.getters['reservation/zoneName'];
		},
	},
});
